module.exports = __webpack_public_path__ + "img/_send_contacts.dfd28647.svg";